import { MAIN_POLYGONS, PARENT_N_CHILD_POLYGONS } from 'shared/common/constants/parentNChildPolygons';
import { IPolygon, IPolygons } from 'shared/common/types/polygons';
import { IPrices } from 'shared/common/types/prices';

type TParams = {
  polygons: IPolygons[];
  prices: IPrices;
};

export const preparePolygons = ({ polygons, prices }: TParams): IPolygon[] => {
  const polygonsId: number[] = [];

  prices.tariffs.map(tariff => {
    if (!polygonsId.find(item => item === tariff.parameters.polygon)) {
      polygonsId.push(tariff.parameters.polygon);
    }
  });

  const filteredPolygons = polygons.filter(polygon => polygonsId.includes(polygon.id));

  const sorted = filteredPolygons.sort((a, b) => a.name.localeCompare(b.name));

  PARENT_N_CHILD_POLYGONS.map(({ parentId, childsIds }) => {
    childsIds.map(child => {
      const elem = sorted.splice(
        sorted.findIndex(elem => elem.id === child),
        1,
      );

      sorted.splice(sorted.findIndex(elem => elem.id === parentId) + 1, 0, {
        ...elem[0],
        leftAdornment: true,
      });
    });
  });

  MAIN_POLYGONS.map(main => {
    const elem = sorted.splice(
      sorted.findIndex(elem => elem.id === main),
      1,
    );
    sorted.splice(0, 0, elem[0]);
  });

  return sorted.map(({ id, name, leftAdornment }) => ({ value: id, label: name, leftAdornment }));
};
